import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Fieldwork } from 'src/app/modules/pages/fieldwork-report/models/fieldwork';
import { RecordsManager } from 'src/app/modules/records/records-manager';
import { MyUtils } from 'src/app/services/my-utils.service';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-selected-date-column',
  templateUrl: './selected-date-column.component.html',
  styleUrls: ['./selected-date-column.component.css']
})
export class SelectedDateColumnComponent implements OnInit, AfterViewInit {

  keySelected: string = 'importDate';
  filters: string[] = ['importDate','eventDate','fieldworkDate']

  constructor(
    private recordsManager: RecordsManager<any>, 
    public utils: MyUtils
  ) { }
  ngAfterViewInit(): void {
    let filterValue = { DateColumn:  'importDate' };
    this.recordsManager.applyAsyncFilter(filterValue); 
  }


  ngOnInit() {
 
  }

  onChange(newValue:string) {

    if (!this.recordsManager.isLoading) {
    let filterValue = { DateColumn: newValue !== 'all' ? newValue : '' };
    this.recordsManager.applyAsyncFilter(filterValue); 
  }
}

  protected readonly environment = environment;
}
